import isEmpty from 'lodash/isEmpty';

import { LaboratoryData } from 'chaika-frontend-types/frontend-cms';
import { LaboratoryIntegrationType } from 'chaika-enums';

import { SimpleList } from '@store/models/SimpleList';

export interface LaboratoryFilterParams {
    ids?: string[];
    legalEntityId?: string;
    integrationType?: LaboratoryIntegrationType;
}

export class LaboratoryList extends SimpleList<LaboratoryData, LaboratoryFilterParams> {
    protected filterValue(value: LaboratoryData, filter: LaboratoryFilterParams): boolean {
        return (
            this.filterFieldValue(value, filter.integrationType, 'integrationType') &&
            this.filterFieldValueByArray(value, filter.ids, 'id') &&
            (isEmpty(value.legalEntityIds) || this.filterArrayFieldValue(value, filter.legalEntityId, 'legalEntityIds'))
        );
    }
}
